import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadcounterService {
  private uploadTotal = new BehaviorSubject([]);
  currentuploadTotal = this.uploadTotal.asObservable();

  changeUploadTotal(upload_total: any) {
    this.uploadTotal.next(upload_total);
  }


  constructor() {}
}
